import {EmSchemaStructureService} from "./service/api/em-schema-structure.service";
import {EmSchemaService} from "./service/api/em-schema.service";
import {EmSchemaRuntimeRecordService} from "./service/api/em-schema-runtime-record.service";
import {EmSchemaRuntimeDataService} from "./service/api/em-schema-runtime-data.service";
import {EmSchemaFieldService} from "./service/api/em-schema-field.service";
import {EmSchemaFieldValueService} from "./service/api/em-schema-field-value.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {
    EmSchemaObjectComponent
} from "./component/object-components/object-component/em-schema-object-component/em-schema-object.component";

export const EM_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['em.EmSchemaField', {route: '/em/emSchemaFields', service: EmSchemaFieldService}],
            ['em.EmSchemaFieldComment', {route: '/em/emSchemaFieldComments'}],
            ['em.EmSchemaStructure', {route: '/em/emSchemaStructures', service: EmSchemaStructureService}],
            ['em.EmSchemaType', {route: '/em/emSchemaTypes'}],
            ['em.EmSchemaFieldValue', {route: '/em/emSchemaFieldValues', service: EmSchemaFieldValueService}],
            ['em.EmSchema', {route: '/em/emSchemas', service: EmSchemaService,}],
            ['em.EmSchemaFieldValueComment', {route: '/em/emSchemaFieldValueComments'}],
            ['em.EmSchemaRuntimeRecord', {route: '/em/emSchemaRuntimeRecords', service: EmSchemaRuntimeRecordService}],
            ['em.EmSchemaRuntimeData', {route: '/em/emSchemaRuntimeData', service: EmSchemaRuntimeDataService}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
